import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { footerStyle } from './Navigation.css';

type Props = ComponentPropsWithRef<'div'>;

export const NavigationFooter = ({ children, className, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(footerStyle, className)}>
      {children}
    </div>
  );
};
